// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"442":"css/app.6994","5127":"css/admin-app.6994"}[chunkId] + ".css";
};